var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMenuForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#54835F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C13.4477 12 13 12.4477 13 13V27C13 27.5523 13.4477 28 14 28H21.7639C20.7084 26.8221 20.7467 25.0106 21.8787 23.8786C23.0095 22.7478 24.8186 22.7085 25.9966 23.7607L26 23.7573V13C26 12.4477 25.5523 12 25 12H14ZM15 16C15 15.4477 15.4477 15 16 15H23C23.5523 15 24 15.4477 24 16C24 16.5523 23.5523 17 23 17H16C15.4477 17 15 16.5523 15 16ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19H16ZM15 24C15 23.4477 15.4477 23 16 23H18C18.5523 23 19 23.4477 19 24C19 24.5523 18.5523 25 18 25H16C15.4477 25 15 24.5523 15 24ZM26 29.4142L30.7071 24.7071C31.0976 24.3166 31.0976 23.6834 30.7071 23.2929C30.3166 22.9024 29.6834 22.9024 29.2929 23.2929L26 26.5858L24.7071 25.2929C24.3166 24.9024 23.6834 24.9024 23.2929 25.2929C22.9024 25.6834 22.9024 26.3166 23.2929 26.7071L26 29.4142Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuForms);
export default __webpack_public_path__ + "static/media/menu_forms.4eebf2af99db11faf32903a0597adb05.svg";
export { ForwardRef as ReactComponent };